const defaultFetchOptions = {
    method: 'get',
    headers: {
        Accept: 'application/json',
    },
};

export const RESPONSE_TYPES = Object.freeze({
    TEXT: 'text',
    JSON: 'json',
});

class Http {
    constructor() {
        this.getOptions = { ...defaultFetchOptions, method: 'get' };
        this.postOptions = { ...defaultFetchOptions, method: 'post' };
    }
    fetch(url, options, { resolve, reject}, responseType = 'json') {
        const hasQueryParams = url.indexOf('?') !== -1;
        fetch(`${url}${hasQueryParams ? '&' : '?'}t=${(new Date()).getTime()}`, options)
            .then((response) => {
                if (response.status !== 200) {
                    reject(response.status);
                    // window.location.href = `${window.location.href}`;
                }
                else {
                    switch (responseType) {
                        case RESPONSE_TYPES.TEXT: {
                            response.text().then(resolve);
                            break;
                        }
                        case RESPONSE_TYPES.JSON: {
                            response.json().then(resolve);
                            break;
                        }
                        default: {
                            resolve(response);
                        }
                    }
                }
            })
            .catch(() => {
                window.location.href = `${window.location.href}`;
            });
    }

    get(url) {
        return new Promise((resolve, reject) => this.fetch(
            `${process.env.REACT_APP_API}${url}`,
            { ...this.getOptions, },
            { resolve, reject },
        ));
    }

    post(url, responseType) {
        return new Promise((resolve, reject) => this.fetch(
            `${process.env.REACT_APP_API}${url}`,
            { ...this.postOptions, },
            { resolve, reject },
            responseType,
        ));
    }

    auth(url) {
        return new Promise((resolve, reject) => this.fetch(
            `${process.env.REACT_APP_AUTH}${url}`,
            { ...this.getOptions, },
            { resolve, reject },
        ));
    }
}
const http = new Http();
export default http;
